// extracted by mini-css-extract-plugin
export var content = "SpeedbumpLink-module--content--045e8";
export var ctaContainer = "SpeedbumpLink-module--ctaContainer--43507";
export var headingContainer = "SpeedbumpLink-module--headingContainer--9b2eb";